import { render, staticRenderFns } from "./ShareSectionDialog.vue?vue&type=template&id=80948300&scoped=true"
import script from "./ShareSectionDialog.vue?vue&type=script&lang=js"
export * from "./ShareSectionDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareSectionDialog.vue?vue&type=style&index=0&id=80948300&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80948300",
  null
  
)

export default component.exports